export { LoyaltyHomeFaqXs } from './LoyaltyHomeFaqXs';
export { LoyaltyHowItWorksModal } from './LoyaltyHowItWorksModal';
export { LoyaltyPointHistoryModal } from './LoyaltyPointHistoryModal';
